module.exports = __webpack_public_path__ + "img/gygx_06.79732d94.jpg";